
import React, { useEffect, useState } from 'react'
import { Grid } from "@material-ui/core";
import useStyle from '../Css/MainCss';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';



const MultiRoleLoginPage = ({ userRoleList, centreId, name, userId }) => {

    console.log("++++++++++++++++++MultiRoleLoginPage+++++++++++++++++");
    console.log(userRoleList);
    

    const classes = useStyle();

    useEffect(() => {
        getSessionData();
    }, [])

    const [displayContent, setDisplayContent] = useState(false);

    function getSessionData() {
        let data = sessionStorage.getItem('sessionstorage');
        data = JSON.parse(data);
        if (data != null) {
            setDisplayContent(false);
            let a = document.createElement('a');
            a.target = '_self';
            a.href = '/dashboardmultiuser/userdets?centreId=' + data.centreId + "&name=" + data.name + "&userId=" + data.userId + "&userRoleId=" + data.userRoleId + "&entityId=" + data.entityId + "&consolidatedId=" + data.consolidatedId;
            a.click();
        } else {
            if (userRoleList.length === 1) {
                setDisplayContent(false);
                let a = document.createElement('a');
                a.target = '_self';
                a.href = '/dashboardmultiuser/userdets?centreId=' + centreId + "&name=" + name + "&userId=" + userId + "&userRoleId=" + userRoleList[0].roleId + "&entityId=" + userRoleList[0].entity.entityId + "&consolidatedId=" + userRoleList[0].entity.consolidatedId;
                setDisplayContent(false);
                a.click();
            }else{
                setDisplayContent(true);
            }
        }
        console.log(data)
    }

    console.log("++++++++++++++++name+++++++++++++++++++");
    console.log(name);

    return (
        <div >
            {displayContent ?
                <Grid container spacing={2}>
                    <Grid container spacing={2} className={classes.pageBodyStyleDB}>
                        <Grid item xs={12} id="tabId1">
                            <div style={{ textAlign: 'center', marginTop: '120px' }}>
                                <Grid container spacing={2}>
                                    {
                                        userRoleList.map((items) => {
                                            return (
                                                <Grid item xs={12}>
                                                    <Link to={`/dashboardmultiuser/userdets?centreId=${centreId}&name=${name}&userId=${userId}&userRoleId=${items.roleId}&entityId=${items.entity.entityId}&consolidatedId=${items.entity.consolidatedId}`}>
                                                        <Button
                                                            variant="contained"
                                                            className={classes.selectRoleTypeBtn}
                                                            //onClick={() => linkToDirectPage()}
                                                            sx={{ boxShadow: 6 }}
                                                        >
                                                            {"Login As " + items.entity.entityName}
                                                        </Button>
                                                    </Link>
                                                </Grid>
                                            )
                                        })
                                    }
                                </Grid>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                :
                ''
            }
        </div>
    )
}

export default MultiRoleLoginPage